<template>
  <div>
    <div class="search flex">
      <span class="tit">消息管理</span>
      <div class="flex">
        <el-button class="addBtn" @click="edit(0)" type="primary" size="small">新增模板消息</el-button>
        <el-button class="addBtn" @click="toWeChat" type="primary" size="small">微信模板消息</el-button>
        <el-input placeholder="请输入名称/手机号/邮箱"
                  class="addART"
                  v-model="condition.messageCode"
                  suffix-icon="el-icon-search"
                  size="small"
                  @change="changeCondition"></el-input>

      </div>
    </div>
    <!--<el-radio-group v-model="condition.messageType" size="small" class="radioGroup" @change="changeCondition">-->
    <!--    <el-radio-button label="">all</el-radio-button>-->
    <!--    <el-radio-button :label="obj.messageType" v-for="obj in tagData"-->
    <!--                     :key="obj.messageType"></el-radio-button>-->
    <!--</el-radio-group>-->
    <div class="instrument">
      <el-table :data="data" class="record-table"
                :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400'}"
                height="calc(100vh - 300px)"
                max-height="calc(100vh - 300px)">
        <el-table-column prop="templateName" label="模板名字" width="230" align="center"
                         show-overflow-tooltip></el-table-column>
        <!--<el-table-column prop="messageType" label="消息类型" width="100" align="center"-->
        <!--                 show-overflow-tooltip></el-table-column>-->
        <el-table-column prop="messageCode" label="消息代码" width="400" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="title" label="消息标题" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" width="140">
          <!-- <template slot="header">
               <el-button size="mini" type="success" icon="el-icon-plus" circle></el-button>
           </template>-->
          <template slot-scope="props">
            <el-button @click="edit(props.row.id)" size="mini" type="text" class="btn">编辑</el-button>
            <el-button size="mini" type="text" class="btn"
                       @click="del(props.row.id,props.row.templateName)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :hide-on-single-page="true"
          class="pagination"
          background
          prev-text="Prev"
          next-text="Next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-size="page.size"
          layout="prev, pager, next"
          :total="page.total">
      </el-pagination>
    </div>
    <!--新增、编辑模板-->
    <el-drawer :title="editType" :wrapperClosable="false"
               :show-close="false" size="600px" class="drawerCommon"
               :visible.sync="dialogFormVisible" :before-close="handleClose">
      <el-form ref="form" label-suffix="：" label-width="90px" class="maxHeight">
        <el-form-item label="模板名字">
          <el-input v-model="addData.templateName"></el-input>
        </el-form-item>
        <el-form-item label="消息类型">
          <!--<el-input v-model="addData.messageType"></el-input>-->
          <el-select v-model="addData.messageType" placeholder="请选择">
            <el-option
                v-for="item in tagData"
                :key="item.messageType"
                :label="item.messageType"
                :value="item.messageType">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消息代码">
          <el-input v-model="addData.messageCode" placeholder="请输入内容(不得重复)"></el-input>
        </el-form-item>
        <el-form-item label="标题">
          <el-autocomplete
              class="inline-input"
              v-model="addData.title"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容" style="width: 100%">

          </el-autocomplete>
        </el-form-item>
        <el-form-item label="正文">
          <el-input v-model="addData.content" type="textarea" :rows="3" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="primary" size="small" @click="add" v-if="editType==='新增模板消息'">新增</el-button>
        <el-button type="primary" size="small" @click="update" v-else>立即更新</el-button>
        <el-button @click="dialogClose" size="small">取消</el-button>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import common from "../../../api/common";

export default {
  name: "templateList",
  data() {
    return {
      page: {
        current: 1,
        size: 11,
        total: 0,
      },
      condition: {
        messageType: '',
        messageCode: '',
      },
      data: [],
      tagData: [],

      addData: {
        id: "",
        content: "",
        messageCode: "",
        messageType: "",
        templateName: "",
        title: '',
      },

      dialogFormVisible: false,
      editType: '',
      suggestion: [],
    }
  },
  mounted() {
    // this.getTag();
    this.getData();
  },
  methods: {
    handleSizeChange(val) {
      this.page.size = val;
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getData();
    },
    changeCondition() {
      this.page.current = 1;
      this.getData();
    },
    getData() {
      let that = this;
      this.$ajax
          .post(common.api.message.template.page.replace("{current}/{size}", this.page.current + "/" + this.page.size), this.condition)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.data = res.data.rows;
              that.page.total = res.data.total;
            }
          })
    },
    getTag() {
      let that = this;
      this.$ajax
          .get(common.api.message.template.tag)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.tagData = res.data.list;
            }
          });
      this.$ajax
          .get(common.api.message.template.inputSuggestion.replace("{number}", 5))
          .then(function (res) {
            if (res.data.status === 'success') {
              for (let i = 0; i < res.data.list.length; i++) {
                that.suggestion.push({'value': res.data.list[i]})
              }
            }
          })
    },
    edit(id) {
      let that = this;
      if (id === 0) {
        that.editType = '新增模板消息';
        that.dialogFormVisible = true;
      } else {
        that.editType = '编辑模板消息';
        this.$ajax
            .get(common.api.message.template.detail.replace("{id}", id))
            .then(function (res) {
              if (res.data.status === 'success') {
                that.addData = res.data.data;
                that.dialogFormVisible = true;
              } else {
                that.$message.error(res.data.message);
              }
            }).catch((err) => {
          console.error(err);
          that.$message.error('操作失败');
        })
      }
    },
    //关闭对话框
    handleClose(done) {
      done();
      this.addData = {};
    },
    //取消
    dialogClose() {
      this.dialogFormVisible = false;
      this.addData = {};
    },
    add() {
      let that = this;
      this.$ajax
          .post(common.api.message.template.add, this.addData)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.$message.success('操作成功');
            } else {
              that.$message.error(res.data.message);
            }
          }).catch((err) => {
        console.error(err);
        that.$message.error('操作失败');
      })
    },
    update() {
      let that = this;
      this.$ajax
          .post(common.api.message.template.update, this.addData)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.$message.success('操作成功');
            } else {
              that.$message.error(res.data.message);
            }
          }).catch((err) => {
        console.error(err);
        that.$message.error('操作失败');
      })
    },
    del(id) {
      let that = this;
      this.$confirm('一旦删除将不可挽回', '确认删除?', {
        confirmButtonText: '删除',
        cancelButtonText: '不删了',
        type: 'warning'
      }).then(() => {
        this.$ajax
            .delete(common.api.message.template.delete.replace("{id}", id))
            .then(function (res) {
              if (res.data.status === 'success') {
                that.$message.success('操作成功');
              } else {
                that.$message.error(res.data.message);
              }
            }).catch((err) => {
          console.error(err);
          that.$message.error('操作失败');
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    querySearch(queryString, cb) {
      let restaurants = this.suggestion;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
      // cb(this.suggestion);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    toWeChat() {
      this.$router.push({path: 'weChat/list'})
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';


.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}


.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>